import api from "../api/axios";

export const setupTwoFactor = async () => {
  const res = await api.post("/api/v1/users/two_factor/setup");
  return res.data;
};

export async function confirmTwoFactor(code) {
  const response = await api.post("/api/v1/users/two_factor/confirm", {
    code,
  });
  return response.data.user; // esto es lo que debe devolver el backend
}

export async function disableTwoFactor() {
  const response = await api.post("/api/v1/users/two_factor/disable");
  return response.data.user;
}
